import { render, staticRenderFns } from "./WritingPad.vue?vue&type=template&id=a177ec68&scoped=true&"
import script from "./WritingPad.vue?vue&type=script&lang=js&"
export * from "./WritingPad.vue?vue&type=script&lang=js&"
import style0 from "./WritingPad.vue?vue&type=style&index=0&id=a177ec68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a177ec68",
  null
  
)

export default component.exports